import BaseLocations from "../../shared/cart/base-locations";

export default BaseLocations;
